import { useState } from 'react';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import ModalTitle from './ModalTitle';
import ModalBody from './ModalBody';
import ModalButton from './ModalButton';

import useGlobalStatus from '../../hook/useGlobalStatus';
import useColorSystem from '../../hook/useColorSystem';
import { ModalPapper } from '../customComponent/box';
import { handleColorSystem } from '../customComponent/colorSystem';
import theme from '../../theme';


const ModalComponent = (props) => {
  const {
    isLoading,
    inputErrorMsg,
    setInputErrorMsg,
    handleModalSubmit,
  } = props;

  const { isModalOpen, setIsModalOpen, editMode, modalContent, modalData, setModalData } = useGlobalStatus();
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();
  const modalBodyPadding = (!modalContent.submitTxt || modalContent.ModalTitle) ? '16px 32px' : '48px 32px 32px 32px';

  const handleClose = () => {
    setIsModalOpen(false);
  }

  return (
    <>
      <Modal
        open={isModalOpen}
        sx={{ zIndex: 2500 }}
      >
        <ModalPapper>
          {
            modalContent.title &&
            <ModalTitle
              editMode={editMode}
              isLoading={isLoading}
              modalContent={modalContent}
              modalData={modalData}
              handleClose={handleClose}
            />
          }
          <Box
            sx={{
              overflow: 'auto',
              padding: modalBodyPadding,
            }}
          >
            <ModalBody
              editMode={editMode}
              isLoading={isLoading}
              inputErrorMsg={inputErrorMsg}
              setInputErrorMsg={setInputErrorMsg}
              modalContent={modalContent}
              modalData={modalData}
              setModalData={setModalData}
              handleModalSubmit={handleModalSubmit}
              handleClose={handleClose}
              mainColor={mainColor}
            />
          </Box>
          {
            (modalContent.submitTxt || modalContent.cancelTxt) &&
            <ModalButton
              isLoading={isLoading}
              inputErrorMsg={inputErrorMsg}
              modalContent={modalContent}
              modalData={modalData}
              setModalData={setModalData}
              handleModalSubmit={handleModalSubmit}
              handleClose={handleClose}
              colorSystem={colorMedia}
            />
          }
        </ModalPapper>
      </Modal >
    </>
  );
};

export default ModalComponent;